import { Button } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { VerticalDivider } from '@hero/atoms';
import { DEVICE } from '@hero/constants';

const CardContent = styled.div`
  flex-grow: 1;
  padding: 16px;
`;

const CardFooterDot = styled.div`
  border-radius: var(--size-border-radius-md);
  height: 8px;
  width: 8px;
`;

const CardFooter = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 9px 16px;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  ${Button.S.Button} {
    font-size: 14px;
  }

  ${DEVICE.mobile.max} {
    ${VerticalDivider} {
      display: none;
    }
  }
`;

const ListContainer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
`;

const ProductAvatar = styled.div`
  border: 2px solid var(--color-accent-primary-inverse-default);
  border-radius: var(--size-border-radius-circle);
  height: 40px;
  overflow: hidden;
  width: 40px;
`;

const ProductArea = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 4px;

  ${ProductAvatar} {
    margin-left: -16px;

    :first-child {
      margin-left: 0;
    }
  }
`;

const AutomationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 36px;
`;

const EmptyLine = styled.div`
  margin-bottom: 16px;
`;

const AutomationCard = styled.div`
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  width: 100%;

  ${({ color, background }) => css`
    border: 1px solid var(--color-border-default);

    ${CardFooter} {
      background-color: ${background};
    }

    ${CardFooterDot} {
      background-color: ${color};
    }
  `}

  &:hover {
    box-shadow: var(--shadow-s);
  }

  ${DEVICE.mobile.max} {
    width: 100%;
  }
`;

export {
  AutomationCard,
  AutomationWrapper,
  CardContent,
  CardFooter,
  CardFooterDot,
  EmptyLine,
  Header,
  ListContainer,
  ProductArea,
  ProductAvatar
};
